import { render, staticRenderFns } from "./part_2.vue?vue&type=template&id=2288686d&scoped=true&"
import script from "./part_2.vue?vue&type=script&lang=js&"
export * from "./part_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2288686d",
  null
  
)

export default component.exports